import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFujifilmComponent } from './simple-icons-fujifilm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFujifilmComponent ],
    exports:      [ SimpleIconsFujifilmComponent ],
    bootstrap:    []
})
export class SimpleIconsFujifilmModule {}
